import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "previews", "droparea"]
  static values = { url: String }

  connect() {
    this.boundDragOver = this.dragOver.bind(this)
    this.boundDragLeave = this.dragLeave.bind(this)
    this.boundDrop = this.drop.bind(this)

    this.dropareaTarget.addEventListener("dragover", this.boundDragOver)
    this.dropareaTarget.addEventListener("dragleave", this.boundDragLeave)
    this.dropareaTarget.addEventListener("drop", this.boundDrop)
  }

  disconnect() {
    this.dropareaTarget.removeEventListener("dragover", this.boundDragOver)
    this.dropareaTarget.removeEventListener("dragleave", this.boundDragLeave)
    this.dropareaTarget.removeEventListener("drop", this.boundDrop)
  }

  dragOver(event) {
    event.preventDefault()
    this.dropareaTarget.classList.add("dropzone--active")
  }

  dragLeave() {
    this.dropareaTarget.classList.remove("dropzone--active")
  }

  drop(event) {
    event.preventDefault()
    this.dropareaTarget.classList.remove("dropzone--active")
    this.uploadFiles(event.dataTransfer.files)
  }

  browse() {
    this.inputTarget.click()
  }

  inputChanged() {
    this.uploadFiles(this.inputTarget.files)
    this.inputTarget.value = ""
  }

  uploadFiles(files) {
    Array.from(files).forEach(file => {
      if (!file.type.startsWith("image/")) return
      this.uploadFile(file)
    })
  }

  uploadFile(file) {
    const preview = this.createPreview(file)
    const progressBar = preview.querySelector(".dropzone-progress-fill")
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    const formData = new FormData()
    formData.append("photo", file)

    const xhr = new XMLHttpRequest()
    xhr.open("POST", this.urlValue)
    xhr.setRequestHeader("X-CSRF-Token", csrfToken)
    xhr.setRequestHeader("Accept", "text/vnd.turbo-stream.html")

    xhr.upload.addEventListener("progress", event => {
      if (event.lengthComputable) {
        const percent = (event.loaded / event.total) * 100
        progressBar.style.width = `${percent}%`
      }
    })

    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        preview.remove()
        Turbo.renderStreamMessage(xhr.responseText)
      } else {
        this.showError(preview, xhr.responseText || "Upload failed")
      }
    })

    xhr.addEventListener("error", () => {
      this.showError(preview, "Network error")
    })

    xhr.send(formData)
  }

  createPreview(file) {
    const div = document.createElement("div")
    div.classList.add("dropzone-preview")
    div.innerHTML = `
      <div class="dropzone-preview-img-wrap">
        <img class="dropzone-preview-img" alt="Uploading...">
      </div>
      <div class="dropzone-progress"><div class="dropzone-progress-fill"></div></div>
      <div class="dropzone-error hidden"></div>
    `
    const img = div.querySelector("img")
    const reader = new FileReader()
    reader.onload = (e) => { img.src = e.target.result }
    reader.readAsDataURL(file)

    this.previewsTarget.appendChild(div)
    return div
  }

  showError(preview, message) {
    const bar = preview.querySelector(".dropzone-progress-fill")
    const error = preview.querySelector(".dropzone-error")
    bar.style.width = "100%"
    bar.style.background = "#EF4444"
    error.textContent = message
    error.classList.remove("hidden")
  }
}
